import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../../contexts/authContext';
import { SolutionTab } from '../../Solution/SolutionTab';
import { usePursuitRecord } from '../PursuitRecordContext';
import { PursuitSectionFrame } from '../PursuitSectionFrame';
/** Solution (Working papers): same solutionRevision / solutionTarget params as the tab. */ export function SolutionSection() {
    const { captureProjectId } = usePursuitRecord();
    // GRW-30: sections always sit in the record shell, so the gate is the header capabilities.
    const { canEdit } = usePursuitRecord().capabilities;
    const { user } = useAuth();
    const [params] = useSearchParams();
    return /*#__PURE__*/ _jsx(PursuitSectionFrame, {
        title: "Solution",
        children: /*#__PURE__*/ _jsx(SolutionTab, {
            readOnly: !canEdit,
            author: user ?? undefined,
            captureProjectId: captureProjectId,
            pinnedRevisionId: params.get('solutionRevision') ?? undefined,
            pinnedTargetId: params.get('solutionTarget') ?? undefined
        })
    });
}
